/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Wiz_HintInputs */

const cs_addr_wiz_hint = /** @type {(inputs: Addr_Wiz_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro nabídky spárované s existujícími nemovitostmi v CRM dohledá chybějící části adresy v RÚIAN.`)
};

const en_addr_wiz_hint = /** @type {(inputs: Addr_Wiz_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looks up missing address parts in RÚIAN for offers matched to existing CRM properties.`)
};

/**
* | output |
* | --- |
* | "Looks up missing address parts in RÚIAN for offers matched to existing CRM properties." |
*
* @param {Addr_Wiz_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_wiz_hint = /** @type {((inputs?: Addr_Wiz_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Wiz_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_wiz_hint(inputs)
	return cs_addr_wiz_hint(inputs)
});